import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CampaignAddTile from "signoxe/components/CampaignAddTile";
import { confirmationRequest, addCampaign } from "signoxe/actions";
import CampaignTile from "signoxe/components/CampaignTile";
import CampaignTileDroppable from "signoxe/components/CampaignTileDroppable";
import "./styles.scss";
import { getCampaigns } from "signoxe/selectors/campaigns";
import { CAMPAIGN_RESOURCE } from "signoxe/api/resources";

class CampaignTileView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canAdd: false,
      campaignName: "",
    };
  }

  showAddForm = () => {
    this.setState({ canAdd: true });
    console.log("Add New Campaign");
  };

  resetCampaignUI = () => {
    this.setState({ canAdd: false, campaignName: "" });
  };

  addNewCampaign = (e) => {
    e.preventDefault();
    const { campaignName } = this.state;
    this.setState({ canAdd: false, campaignName: "" });
    this.props.addCampaign({ name: campaignName });
  };

  handleNameChange = (e) => {
    this.setState({ campaignName: e.target.value });
  };

  deleteCampaign = (campaign) => {
    this.props.confirmationRequest(
      "Deleting campaign",
      `Are you sure you want to remove "${campaign.name}" from assets? .  All assets inside the campaign would be deleted too. `,
      "DELETE",
      CAMPAIGN_RESOURCE,
      campaign.id
    );
    console.log("delete Campaign = ", campaign);
  };

  render() {
    const { canAdd } = this.state;
    const { campaigns, onDrop, onView } = this.props;

    return (
      <>
        <div className="CampaignTile">
          <CampaignAddTile
            onClickAdd={this.showAddForm}
            canAdd={canAdd}
            onNameChange={this.handleNameChange}
            onCancel={this.resetCampaignUI}
            onAdd={this.addNewCampaign}
          />
        </div>
        {campaigns &&
          campaigns.length > 0 &&
          campaigns.map((camapaign, index) => (
            <CampaignTileDroppable
              campaign={camapaign}
              key={index}
              onDrop={onDrop}
              onView={onView}
            >
              <CampaignTile
                campaign={camapaign}
                onDelete={this.deleteCampaign}
                onView={onView}
              />
            </CampaignTileDroppable>
          ))}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

CampaignTileView.prototypes = {
  onDrop: PropTypes.func.isRequired,
  campaigns: PropTypes.array.isRequired,
};

export default connect(mapStateToProps, {
  addCampaign,
  confirmationRequest,
})(CampaignTileView);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/CampaignTileView/index.js